import { FootSizeData, ArchHeightData, WeightRangeData } from '../types/foot';

export const FOOT_SIZE_DATA: {
  [key: string]: FootSizeData;
} = {
  "5": {
    mmRange: "214.4-224.4",
    lessThan: 224.4,
    greaterThanOrEqual: 214.4,
    label: "W 6, M 5",
    men: "5",
    women: "6",
  },
  "6": {
    mmRange: "224.4-232.8",
    lessThan: 232.8,
    greaterThanOrEqual: 224.4,
    label: "W 7, M 6",
    men: "6",
    women: "7",
  },
  "7": {
    mmRange: "232.8-241.3",
    lessThan: 241.3,
    greaterThanOrEqual: 232.8,
    label: "W 8, M 7",
    men: "7",
    women: "8",
  },
  "8": {
    mmRange: "241.3-249.8",
    lessThan: 249.8,
    greaterThanOrEqual: 241.3,
    label: "W 9, M 8",
    men: "8",
    women: "9",
  },
  "9": {
    mmRange: "249.8-258.2",
    lessThan: 258.2,
    greaterThanOrEqual: 249.8,
    label: "W 10, M 9",
    men: "9",
    women: "10",
  },
  "10": {
    mmRange: "258.2-266.7",
    lessThan: 266.7,
    greaterThanOrEqual: 258.2,
    label: "W 11, M 10",
    men: "10",
    women: "11",
  },
  "11": {
    mmRange: "266.7-275.2",
    lessThan: 275.2,
    greaterThanOrEqual: 266.7,
    label: "W 12, M 11",
    men: "11",
    women: "12",
  },
  "12": {
    mmRange: "275.2-283.6",
    lessThan: 283.6,
    greaterThanOrEqual: 275.2,
    label: "W 13, M 12",
    men: "12",
    women: "13",
  },
  "13": {
    mmRange: "283.6-292.1",
    lessThan: 292.1,
    greaterThanOrEqual: 283.6,
    label: "W 14, M 13",
    men: "13",
    women: "14",
  },
  "14": {
    mmRange: "292.1-300.6",
    lessThan: 300.6,
    greaterThanOrEqual: 292.1,
    label: "W 15, M 14",
    men: "14",
    women: "15",
  },
  "15": {
    mmRange: "300.6-310.6",
    lessThan: 310.6,
    greaterThanOrEqual: 300.6,
    label: "W 16, M 15",
    men: "15",
    women: "16",
  },
};

export const FOOT_SIZE_DATA_ORDERED = [
  FOOT_SIZE_DATA["5"],
  FOOT_SIZE_DATA["6"],
  FOOT_SIZE_DATA["7"],
  FOOT_SIZE_DATA["8"],
  FOOT_SIZE_DATA["9"],
  FOOT_SIZE_DATA["10"],
  FOOT_SIZE_DATA["11"],
  FOOT_SIZE_DATA["12"],
  FOOT_SIZE_DATA["13"],
  FOOT_SIZE_DATA["14"],
  FOOT_SIZE_DATA["15"],
];

export const ARCH_HEIGHT_DATA: {
  [key: string]: ArchHeightData;
} = {
  "1": {
    mmRange: "<=14",
    lessThanOrEqualTo: 14,
    greaterThan: 0,
    bucket: 1,
    type: 'Very Low',
    pillText: 'Low',
  },
  "2": {
    mmRange: "14-18",
    lessThanOrEqualTo: 18,
    greaterThan: 14,
    bucket: 2,
    type: 'Low',
    pillText: 'Low',
  },
  "3": {
    mmRange: "18-22",
    lessThanOrEqualTo: 22,
    greaterThan: 18,
    bucket: 3,
    type: 'Low',
    pillText: 'Low',
  },
  "4": {
    mmRange: "22-26",
    lessThanOrEqualTo: 26,
    greaterThan: 22,
    bucket: 4,
    type: 'Medium',
    pillText: 'Medium',
  },
  "5": {
    mmRange: "26-30",
    lessThanOrEqualTo: 30,
    greaterThan: 26,
    bucket: 5,
    type: 'Medium',
    pillText: 'Medium',
  },
  "6": {
    mmRange: "30-34",
    lessThanOrEqualTo: 34,
    greaterThan: 30,
    bucket: 6,
    type: 'Medium',
    pillText: 'Medium',
  },
  "7": {
    mmRange: "34-38",
    lessThanOrEqualTo: 38,
    greaterThan: 34,
    bucket: 7,
    type: 'High',
    pillText: 'High',
  },
  "8": {
    mmRange: "38-42",
    lessThanOrEqualTo: 42,
    greaterThan: 38,
    bucket: 8,
    type: 'High',
    pillText: 'High',
  },
  "9": {
    mmRange: ">42",
    lessThanOrEqualTo: Infinity,
    greaterThan: 42,
    bucket: 9,
    type: 'Very High',
    pillText: 'High',
  },
};

export const ARCH_HEIGHT_DATA_ORDERED = [
  ARCH_HEIGHT_DATA["1"],
  ARCH_HEIGHT_DATA["2"],
  ARCH_HEIGHT_DATA["3"],
  ARCH_HEIGHT_DATA["4"],
  ARCH_HEIGHT_DATA["5"],
  ARCH_HEIGHT_DATA["6"],
  ARCH_HEIGHT_DATA["7"],
  ARCH_HEIGHT_DATA["8"],
  ARCH_HEIGHT_DATA["9"]
];

export const WEIGHT_DATA: {
  [key: string]: WeightRangeData;
} = {
  "<77": {
    lbsRange: "<77",
    lessThan: 77,
    greaterThanOrEqual: 0,
    label: "< 77 lbs",
    bucket: 1,
  },
  "77-110": {
    lbsRange: "77-110",
    lessThan: 110,
    greaterThanOrEqual: 77,
    label: "77 - 110 lbs",
    bucket: 2,
  },
  "110-132": {
    lbsRange: "110-132",
    lessThan: 132,
    greaterThanOrEqual: 110,
    label: "110 - 132 lbs",
    bucket: 3,
  },
  "132-154": {
    lbsRange: "132-154",
    lessThan: 154,
    greaterThanOrEqual: 132,
    label: "132 - 154 lbs",
    bucket: 4,
  },
  "154-176": {
    lbsRange: "154-176",
    lessThan: 176,
    greaterThanOrEqual: 154,
    label: "154 - 176 lbs",
    bucket: 5,
  },
  "176-198": {
    lbsRange: "176-198",
    lessThan: 198,
    greaterThanOrEqual: 176,
    label: "176 - 198 lbs",
    bucket: 6,
  },
  "198-221": {
    lbsRange: "198-221",
    lessThan: 221,
    greaterThanOrEqual: 198,
    label: "198 - 221 lbs",
    bucket: 7,
  },
  "221-243": {
    lbsRange: "221-243",
    lessThan: 243,
    greaterThanOrEqual: 221,
    label: "221 - 243 lbs",
    bucket: 8,
  },
  "243-265": {
    lbsRange: "243-265",
    lessThan: 265,
    greaterThanOrEqual: 243,
    label: "243 - 265 lbs",
    bucket: 9,
  },
  "265-287": {
    lbsRange: "265-287",
    lessThan: 287,
    greaterThanOrEqual: 265,
    label: "265 - 287 lbs",
    bucket: 10,
  },
  "287+": {
    lbsRange: "287+",
    lessThan: Infinity,
    greaterThanOrEqual: 287,
    label: "287+ lbs",
    bucket: 11,
  },
};

export const WEIGHT_RANGE_ORDERED = [
  WEIGHT_DATA["<77"],
  WEIGHT_DATA["77-110"],
  WEIGHT_DATA["110-132"],
  WEIGHT_DATA["132-154"],
  WEIGHT_DATA["154-176"],
  WEIGHT_DATA["176-198"],
  WEIGHT_DATA["198-221"],
  WEIGHT_DATA["221-243"],
  WEIGHT_DATA["243-265"],
  WEIGHT_DATA["265-287"],
  WEIGHT_DATA["287+"],
];

export const FOAM_PACKAGE_TYPES = {
  SUPERREV: 'superrev',
  SUPERREV_ELITE: 'superrev_elite',
} as const;

export type FoamPackageType = typeof FOAM_PACKAGE_TYPES[keyof typeof FOAM_PACKAGE_TYPES];

export const FOAM_PACKAGE_SHOPIFY_OPTIONS = {
  [FOAM_PACKAGE_TYPES.SUPERREV]: "SuperRev™",
  [FOAM_PACKAGE_TYPES.SUPERREV_ELITE]: "SuperRev™ Max",
};

export const FOAM_PACKAGE_PERSONALIZATION_SUB_TEXT = {
  [FOAM_PACKAGE_SHOPIFY_OPTIONS['superrev']]: {
    title: "SuperRev™",
    text: "Fits best in all footwear, including tight fitting shoes",
  },
  [FOAM_PACKAGE_SHOPIFY_OPTIONS['superrev_elite']]: {
    title: "SuperRev™ Max",
    text: "Fits best in moderate to roomy fitting shoes",
  },
};
